module.exports = __webpack_public_path__ + "static/img/ninja-can-17.1e69a8be.png";